import { useState } from "react";
import { Loader2 } from "lucide-react";

// PATCH 37 Mi4 — one loading-button contract: on click the label is replaced by a spinner while the
// async handler runs, and the button is disabled. Width is preserved to avoid layout shift.
export default function LoadingButton({ onClick, children, className = "k-btn k-btn-primary", disabled, testid, type = "button", style }) {
  const [loading, setLoading] = useState(false);
  const run = async (e) => {
    if (loading || disabled) return;
    setLoading(true);
    try { await onClick?.(e); } finally { setLoading(false); }
  };
  return (
    <button type={type} className={className} data-testid={testid} data-loading={loading ? "true" : "false"}
      disabled={disabled || loading} onClick={run} style={style} aria-busy={loading}>
      {loading ? <Loader2 size={15} className="k-spin" aria-hidden="true" /> : children}
    </button>
  );
}
